import { Pipe, PipeTransform } from '@angular/core';
import {Team} from '@app/state/game-mode.state';

@Pipe({
  name: 'teamName'
})
export class TeamNamePipe implements PipeTransform {

  public transform(teams: Team[], teamId: number): string {
    for (const item of teams) {
      if (item.id === teamId) {
        return item.name;
      }
    }

    return '';
  }
}
